import { Cwb_PositionalAttribute } from "../../../../Shared/Shared.js";
import { singleton } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export const nlex = new Cwb_PositionalAttribute("nlex", "Non-lexical");

export const list = singleton(nlex);

